import _ from 'lodash';
import { RadioButton, RadioButtonGroup } from 'material-ui';
import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import MultiSelect, { MultiSelectOption } from '../../../core/modules/common/components/MultiSelect';
import OPERATORS from '../constants/operators';
import { sortRowValues } from '../helpers/sortValues';
import ColumnFilter from './ColumnFilter';

const isValid = (operator, number, endNumber) => {
  if (Number.isNaN(Number(number))) {
    return false;
  }

  if (operator === OPERATORS.BETWEEN) {
    return !Number.isNaN(Number(endNumber)) && (endNumber > number);
  }

  return true;
};

const initialCurrent = {
  operator: OPERATORS.EQUALS,
  number: NaN,
  endNumber: NaN,
  valid: false,
};

class NumberFilter extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      multiSelectOptions: this.getOrderedUniqueValues(props),
    };
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (!_.isEqual(nextProps.data, this.props.data)) {
      this.setState({
        multiSelectOptions: this.getOrderedUniqueValues(nextProps),
      });
    }
  }

  getOrderedUniqueValues = props => _(props.data)
    .map((row) => {
      const value = props.column.accessor(row);
      if (value === undefined || value === '' || value === null || (Array.isArray(value) && value.length === 0)) {
        return new MultiSelectOption(null, '(Blank)');
      }

      if ((Array.isArray(value) && value.length)) {
        let labels;
        if (props.column.Cell && typeof props.column.Cell === 'function' && !props.column.navOptionsCallback) {
          labels = props.column.Cell.apply(this, [{ value }]);
          return value.map((v, i) => new MultiSelectOption(v, labels[i]));
        }
        return value.map(v => new MultiSelectOption(v));
      }

      let label = value;
      if (props.column.Cell && typeof props.column.Cell === 'function') {
        label = props.column.Cell.apply(null, [{ value }, false]);
      }
      return new MultiSelectOption(value, label);
    })
    .flatten()
    .uniqBy('value')
    .value()
    .sort(sortRowValues);

  render() {
    return (
      <ColumnFilter
        {...this.props}
        render={(current = initialCurrent, setCurrent) => (
          <div>
            <div className="advanced-filter__fields">
              <MultiSelect
                name="unique-number-select"
                value={current.multiSelectValues}
                onChange={value => setCurrent({
                  ...current,
                  multiSelectValues: value,
                  valid: value.length > 0,
                })}
                options={this.state.multiSelectOptions}
              />
            </div>
            <div className="advanced-filter__fields">
              <RadioButtonGroup
                onChange={(event, operator) => {
                  setCurrent({ ...current, operator });
                }}
                name="numberFilter"
                valueSelected={current.operator}
              >
                <RadioButton
                  value={OPERATORS.EQUALS}
                  label={<FormattedMessage id="filter-component.label.equals" />}
                />
                <RadioButton
                  value={OPERATORS.GREATER_THAN}
                  label={<FormattedMessage id="filter-component.label.greater-than" />}
                />
                <RadioButton
                  value={OPERATORS.GREATER_THAN_EQUAL_TO}
                  label={<FormattedMessage id="filter-component.label.greater-than-equal-to" />}
                />
                <RadioButton
                  value={OPERATORS.SMALLER_THAN}
                  label={<FormattedMessage id="filter-component.label.smaller-than" />}
                />
                <RadioButton
                  value={OPERATORS.SMALLER_THAN_EQUAL_TO}
                  label={<FormattedMessage id="filter-component.label.smaller-than-equal-to" />}
                />
                <RadioButton
                  value={OPERATORS.BETWEEN}
                  label={<FormattedMessage id="filter-component.label.between" />}
                />
              </RadioButtonGroup>
            </div>

            <div className="advanced-filter__fields">
              <input
                className="number-input"
                type="number"
                min="0"
                pattern="[0-9]"
                onChange={(event) => {
                  const number = parseFloat(event.target.value);
                  const valid = isValid(current.operator, number, current.endNumber);
                  setCurrent({
                    ...current,
                    number,
                    valid,
                  });
                }}
                value={current.number}
              />
              {current.operator === OPERATORS.BETWEEN &&
              <input
                className="number-input"
                type="number"
                min="0"
                pattern="[0-9]"
                onChange={(event) => {
                  const endNumber = parseFloat(event.target.value);
                  const valid = isValid(current.operator, current.number, endNumber);
                  setCurrent({
                    ...current,
                    endNumber,
                    valid,
                  });
                }}
                value={current.endNumber}
              />
              }
            </div>
          </div>
        )}
      />
    );
  }
}

NumberFilter.propTypes = {
  data: PropTypes.arrayOf(PropTypes.object),
};

export default NumberFilter;
